export const SET_LOGGEDIN = 'SET_LOGGEDIN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_SELLERCREATION = 'SET_SELLERCREATION'
export const SET_ACCOUNTTYPE = 'SET_ACCOUNTTYPE'
export const SET_BUYNOWPRODUCTS = 'SET_BUYNOWPRODUCTS'
export const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS'
export const SET_REGION = 'SET_REGION'
export const SET_FlAWFILTER = 'SET_FlAWFILTER'
export const SET_OCCUPATIONFILTER = 'SET_OCCUPATIONFILTER'
export const SET_ZODIACFILTER = 'SET_ZODIACFILTER'
export const SET_STATUSFILTER = 'SET_STATUSFILTER'
export const SET_COUNT_API = "SET_COUNT_API"
export const SET_EDUCATIONLIST = "SET_EDUCATIONLIST"
export const SET_FULL_EDUCATIONLIST = "SET_FULL_EDUCATIONLIST"
export const SET_ZODIACSIGNS = "SET_ZODIACSIGNS"
export const SET_FLAWS = "SET_FLAWS"
export const SET_STATUS = "SET_STATUS"
export const SET_OCCUPATION = "SET_OCCUPATION"
export const SET_ALLSTARS = "SET_ALLSTARS"
export const SET_FULL_OCCUPATIONS = "SET_FULL_OCCUPATIONS"
export const SET_TEDUCATIONS = "SET_TEDUCATIONS"
export const SET_TFLAWS = "SET_TFLAWS"
export const SET_TSTATUS = "SET_TSTATUS"
export const SET_TOCCUPATION = "SET_TOCCUPATION"
export const SET_DHISA = 'SET_DHISA'
export const SET_INITIAL_LOADING_FILTER = 'SET_INITIAL_LOADING_FILTER'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_MIN_AGE = 'SET_MIN_AGE'
export const SET_MAX_AGE = 'SET_MAX_AGE'
export const SET_SEARCH_COUNT = 'SET_SEARCH_COUNT'
export const SET_TDHISA ='SET_TDHISA'
export const SET_FETCH_USER_DETAILS = 'SET_FETCH_USER_DETAILS'
export const SET_MOBILE_FILTERS = 'SET_MOBILE_FILTERS'